/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Auf der Karte anzeigen`
};

const en_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `See on the map`
};

const es_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Ver en la mapa`
};

const fr_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Voir sur la carte`
};

const it_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Visualizza sulla mappa`
};

const nl_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijken op de kaart`
};

const pt_poi_datasheet__see_on_map = /** @type {(inputs: {}) => string} */ () => {
	return `Ver no mapa`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__see_on_map(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__see_on_map", locale)
	if (locale === "de") return de_poi_datasheet__see_on_map(inputs)
	if (locale === "en") return en_poi_datasheet__see_on_map(inputs)
	if (locale === "es") return es_poi_datasheet__see_on_map(inputs)
	if (locale === "fr") return fr_poi_datasheet__see_on_map(inputs)
	if (locale === "it") return it_poi_datasheet__see_on_map(inputs)
	if (locale === "nl") return nl_poi_datasheet__see_on_map(inputs)
	return pt_poi_datasheet__see_on_map(inputs)
};